<template lang="pug">
	
	.engagement-slider
	
		.movable
			.left-layer
				.layer

				.layer-content
					h3.fact-title JOEY BADA$$ </br><span>vs</span> BARACK OBAMA
					
					.fact
						.fact-thumb
							img(src="assets/images/obama-daughter.jpg")
						.fact-text
							p.text(v-html="translate('engagement.text_left_1')")
					
					.fact
						.fact-thumb
							img(src="assets/images/joey-coachella.jpg")
						.fact-text
							p.text(v-html="translate('engagement.text_left_2')")
					
					.fact
						.fact-thumb
							img(src="assets/images/joey-about-obama.jpg")
						.fact-text
							p.text(v-html="translate('engagement.text_left_3')")

			.slider-container
				.slider

					.slider-movable
						.slider-column
							video-element(href='https://www.youtube.com/watch?v=kg00mbfXsEI' :onEnter="fadeElements" :onLeave="resetElement" :item="0"  ref="video0" poster="assets/images/engagment-video-1.jpg" width="577" height="323" title="We will not - T.I.")

							.text.text-1
								p(v-html="translate('engagement.text_3')")

						.slider-column
							video-element( href='https://www.youtube.com/watch?v=WDZJPJV__bQ' :onEnter="fadeElements" :item="1" :onLeave="resetElement" ref="video1" poster="assets/images/engagment-video-2.jpg" width="430" height="240" title="Formation - Beyoncé")
							video-element( href='https://www.youtube.com/watch?v=RM7lw0Ovzq0' :onEnter="fadeElements" :item="2" :onLeave="resetElement" ref="video2" poster="assets/images/engagment-video-3.jpg" width="430" height="240" title="The story of 0.J. - Jay-Z")
							
						.slider-column
							video-element( href='https://www.youtube.com/watch?v=Z-48u_uWMHY' :onEnter="fadeElements" :item="3" :onLeave="resetElement" ref="video3" poster="assets/images/engagment-video-4.jpg" width="430" height="240" title="Alright - Kendrick Lamar")
					
							
						.slider-column
							video-element( href='https://www.youtube.com/watch?v=hsMraWleiCQ' :onEnter="fadeElements" :item="4" :onLeave="resetElement" ref="video4" poster="assets/images/engagment-video-6.jpg" width="430" height="240" title="Mosh (Explicit) - eminem")
							video-element( href='https://www.youtube.com/watch?v=U3OD3mlJdT8' :onEnter="fadeElements" :item="5" :onLeave="resetElement" ref="video5" poster="assets/images/engagment-video-5.jpg" width="577" height="323" title="YG - YNS ft. Blac Youngsta, YFN Lucci")


						.slider-column
							video-element( href='https://www.youtube.com/watch?v=c7zyAtkw6ac' :onEnter="fadeElements" :item="6" :onLeave="resetElement" ref="video6" poster="assets/images/engagment-video-7.jpg" width="577" height="323" title="Holler If Ya Hear Me - 2Pac")
							video-element( href='https://www.youtube.com/watch?v=9jOqOlETcRU' :onEnter="fadeElements" :item="7" :onLeave="resetElement" ref="video7" poster="assets/images/engagment-video-8.jpg" width="430" height="240" title="Fuck Tha Police - N.W.A.")


						.slider-column
							video-element( href='https://www.youtube.com/watch?v=8PaoLy7PHwk' :onEnter="fadeElements" :item="8" :onLeave="resetElement" ref="video8" poster="assets/images/engagment-video-9.jpg" width="430" height="240" title="Fight The Power - Public Enemy")
							video-element( href='https://www.youtube.com/watch?v=-SoKFycTmVU' :onEnter="fadeElements" :item="9" :onLeave="resetElement" ref="video9" poster="assets/images/engagment-video-10.jpg" width="577" height="323" title="New Slaves - Kanye West")

						.slider-column.movable-column
							video-element( href='https://www.youtube.com/watch?v=xE8ct6FvMN0' :onEnter="fadeElements" :item="10" :onLeave="resetElement" ref="video10" poster="assets/images/engagment-video-11.jpg" width="577" height="323" title="BUFFALO - Tyler, The Creator")
							
							.text.text-2
								p(v-html="translate('engagement.text_4')")
	
</template>

<script>
		
	import Vue from 'vue'
	import Component from 'vue-class-component'
	import $ from 'jquery'
	import { TweenMax } from 'gsap'
	import Scroller from '../../../utils/scroller.js'
	import Ticker from '../../../utils/ticker.js'
	import * as PIXI from 'pixi.js'
	import Scrollable from '../../../abstracts/scrollable'
	import VideoElement from '~components/video-element.vue'
	import Globals from '~utils/Globals.js'
	
  	@Component({
		name: 'EngagementSlider',
		components: { VideoElement }
	})

	class EngagementSlider extends Scrollable {

		mounted () {
			super.mounted()
			

			this._dom()
		}

		init () {
			super.init()

			this.isResized = false

		}

		_bind () {
			super._bind()

			// this.fadeElements = this.fadeElements.bind(this)
			// this.resetElement = this.resetElement.bind(this)
		}

		_dom () {
			
			this.$slider = this.$el.querySelector('.slider-movable')
			this.$movable = this.$el.querySelector('.movable')

			this.$leftLayer = this.$el.querySelector('.left-layer')
			this.$layer = this.$el.querySelector('.left-layer .layer')
			this.$layerTitle = this.$el.querySelectorAll('.fact-title')
			this.$layerThumbs = this.$el.querySelectorAll('.fact .fact-thumb')
			this.$layerTexts = this.$el.querySelectorAll('.fact .fact-text')

			this.$movableColumn = this.$el.querySelectorAll('.slider-column:not(.movable-column)')
				}

		raf(y) {
			super.raf(y)
		}

		fadeElements (index) {
			const count = 11

			for(let i = 0; i < count; i ++ ) {
				if(i === index) {
					continue
				} 
				TweenMax.to(this.$refs[`video${i}`].$el,.3,{opacity:.2, ease:Power3.easeInOut})
			}

		}

		resetElement () {
			const count = 11

			for(let i = 0; i < count; i ++ ) {
				TweenMax.to(this.$refs[`video${i}`].$el,.3,{opacity:1, ease:Power3.easeInOut})
			}
		}

		initTimeline () {
			super.initTimeline()

						
			this.tlAppear.set(this.$leftLayer,{autoAlpha:1})
			this.tlAppear.fromTo(this.$layer,.8,{x:'-100%'},{x:'0%',ease: Power3.easeOut},0)
			this.tlAppear.fromTo(this.$layerTitle,.8,{y:40,opacity:0},{y:0,opacity:1,ease: Power3.easeOut},0)
			this.tlAppear.staggerFromTo(this.$layerThumbs,.8,{y:40,opacity:0},{y:0,opacity:1,ease: Power3.easeOut},.1,.1)
			this.tlAppear.staggerFromTo(this.$layerTexts,.8,{y:40,opacity:0},{y:0,opacity:1,ease: Power3.easeOut},.1,.2)


			// window.height ratio on total height
			const h_ratio = Globals.height / this.bounds.height
			const appearTime = (this.offset) / this.bounds.height

			const videoPos = [
				{
					x: 0,
					y: 0,
					xgap: 100
				},
				{
					x: 10,
					y: -.3,
					xgap: 80
				},
				{
					x: 200,
					y: .5,
					xgap: 300
				},
				{	
					x: -50,
					y: -.2,
					xgap: -200
				},
				{
					x: 300,
					y: -.5,
					xgap: 130
				},
				{
					x: -80,
					y: .6,
					xgap: 0
				},
				{
					x: 0,
					y: 1,
					xgap: 20
				},
				{
					x: -60,
					y: .3,
					xgap: -100
				},
				{
					x: 100,
					y: -.5,
					xgap: 100
				},
				{
					x: -90,
					y: .3,
					xgap: -90
				}							
			]
	
			const w_h = window.innerHeight

			this.tl.fromTo(this.$movable,1,{y:0},{y: this.offset + Globals.height,ease:Power0.easeNone},0)
			this.tl.fromTo(this.$slider,(1-h_ratio),{x:0},{x:-this.offset,ease:Power0.easeNone},0)
			this.tl.fromTo(this.$movableColumn,h_ratio,{y:0},{y:-w_h*.3,ease:Power0.easeNone},(1 - h_ratio))
			this.tl.add(()=>{

				const p = this.tlAppear.progress()

				if(this.scroller.direction === 1 || this.isResized == false) {
					this.tlAppear.play(p)
				} else {
					this.tlAppear.reverse(p)
				}

				this.isResized = true

			},(1 - h_ratio))


			for(let i = 0; i < videoPos.length; i ++) {

				const v = this.$refs[`video${i}`].$el
				const vImg = [this.$refs[`video${i}`].$posterImg, this.$refs[`video${i}`].$layer]
				const p = videoPos[i]
				const h = v.getBoundingClientRect().height

				this.tl.fromTo(v,(1-h_ratio),
					{x: Globals.responsiveWidth(p.x), y: (window.innerHeight/2 - Globals.responsiveHeight(h)) * p.y },
					{x:Globals.responsiveWidth(p.x - p.xgap),ease:Power0.easeNone}
				,0)
			}
		}

		_resize () {
			super._resize()

			this.isResized = false
						
			this.sliderWidth = this.$slider.getBoundingClientRect().width
			this.offset = this.sliderWidth - window.innerWidth
			this.bounds.height = window.innerHeight * 2 + this.offset
			this.$el.style.height = this.bounds.height + "px"

			this.boundsAnim = {
				top: this.bounds.top,
				bottom: this.bounds.top + this.offset + window.innerHeight
			}

			this.initTimeline ()
		}

		_on () {
			super._on()
		}

		_off () {
			super._off()
			
		}


	}

	export default EngagementSlider

</script>


<style lang="stylus">
	
	@import '../../../theme/utils'
	@import '../../../theme/variables'
	
	.engagement-slider
		width 100%
		height 100vh
		position relative

		.movable
			height 100vh
			width 100%
			position absolute
			top 0
			left 0
			will-change transform

			.left-layer
				width 45vw
				height 100vh
				position absolute
				top 0
				left 0	
				z-index 80
				overflow hidden
				opacity 0
				visibility hidden

				.layer
					height 100%
					width 100%
					position absolute
					top 0
					left 0
					background-color #fff
					z-index 30
					transform translateX(-100%)

				.layer-content
					position relative
					z-index 40
					display flex
					flex-direction column
					justify-content center
					align-items center
					height 100%

					.fact
						max-width 390px
						display flex
						align-items center
						margin-bottom 16px

						.fact-thumb
							height 150px
							min-width 150px
							transform translateY(40px)
							opacity 0

							img
								width 100%
								height 100%
								object-fit cover

						.fact-text
							padding-left 16px
							transform translateY(40px)
							opacity 0

							.text
								font-size em(15px)
								line-height em(24px, 15px)
								color $COLOR_BLUE
								font-family $FONT_THIRDLY

								a
									color currentColor

					.fact-title
						color $COLOR_BLUE
						font-size em(24px)
						font-family $FONT_SECONDARY
						letter-spacing .15em
						font-weight 700
						max-width 200px
						text-align center
						margin-bottom 32px
						transform translateY(40px)
						opacity 0

						span,a
							font-weight 300


				

			.slider-container
				width 100%
				height 100%
				display flex
				align-items center
				position relative
				overflow hidden

				.slider
					width 999999px
					display flex
				
					.slider-movable
						display flex
						align-items center
						padding-left 210px
						padding-right 10vh
						height 100vh
						will-change transform

				.slider-column
					position relative
					// height 100vh
					margin-left 20px
					display flex
					flex-direction column
					justify-content space-between

					.text

						margin-top 30px
						
						&.text-1
							max-width 380px
							text-align center
							margin-left auto
							margin-right auto

						&.text-2
							max-width 100%
							text-align left
						
						p
							font-size em(15px)
							color #ffffff
							line-height em(24px, 15px)
							font-family $FONT_THIRDLY
</style>


// WEBPACK FOOTER //
// engagement-slider.vue?a46d5be0